<template>
  <div v-if="actionsPage" id="applicant-edit-tab-internal-history">
    <div class="vx-row">
      <div class="vx-col w-full md:w-1/2"></div>
    </div>
    <div class="vx-row">
      <div v-if="!viewOnly" class="vx-col w-full mb-8">
        <div class="custom-accordion plus-icon">
          <div
            class="custom-accordion--item"
            :class="{
              'is-active': 1 === selected
            }"
          >
            <button class="custom-accordion--header" @click="openForm(1)">
              Eintrag anlegen
              <i class="fal fa-plus"></i>
            </button>
            <div class="accordion-content">
              <ActionForm
                v-model="form"
                :type="isHistory ? 'HISTORY' : 'RESUBMISSION'"
                @submit="submitActionForm"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="vx-col w-full">
        <vs-table :data="actionsPage.results">
          <template slot="header">
            <h3 class="mb-4">
              {{ isHistory ? "Historie" : "Wiedervorlagen" }}
            </h3>
          </template>
          <template slot="thead">
            <vs-th v-if="showRemindAt">Datum</vs-th>
            <vs-th>Berater</vs-th>
            <vs-th>Art</vs-th>
            <vs-th>Betreff</vs-th>
            <vs-th>Erstellt am</vs-th>
            <vs-th v-if="!viewOnly">Aktion</vs-th>
            <vs-th v-if="showCompanyContact">Ansprechpartner</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr v-for="(entry, i) in data" :key="entry.id" :data="entry">
              <vs-td v-if="showRemindAt">
                {{ entry.remindAt ? $d(new Date(entry.remindAt), "long") : "" }}
              </vs-td>

              <vs-td>
                {{ entry.consultant ? entry.consultant.firstName : "" }}
                {{ entry.consultant ? entry.consultant.lastName : "" }}
              </vs-td>

              <vs-td>
                {{ entry.type ? entry.type[nameColumn] : "" }}
              </vs-td>

              <vs-td>
                {{ entry.title ? entry.title : "" }}
              </vs-td>

              <vs-td>
                {{ $d(new Date(entry.createdAt), "long") }}
              </vs-td>

              <vs-td v-if="!viewOnly">
                <feather-icon
                  v-if="!isHistory"
                  icon="check"
                  svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                  @click="doneEntry(i, entry)"
                />
                <feather-icon
                  v-if="!entry.automatic"
                  icon="pen"
                  svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                  @click="editEntry(i, entry)"
                />
                <feather-icon
                  icon="trash"
                  svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                  @click="deleteRecord(i, entry)"
                />
              </vs-td>
              <vs-td v-if="showCompanyContact">
                {{ entry.companyContact ? entry.companyContact.firstName : "" }}
                {{ entry.companyContact ? entry.companyContact.lastName : "" }}
              </vs-td>

              <template slot="expand" class="expand-resource">
                <div
                  v-if="entry.companyContact"
                  class="
                    w-full
                    flex flex-row flex-nowrap
                    justify-between
                    gap-10
                  "
                >
                  <div class="flex-grow">
                    <div v-if="entry.project" class="entry-title">
                      {{ entry.project ? entry.project.number : "-" }}
                      {{ entry.project ? entry.project.title : "" }}
                    </div>
                    <parsed-text
                      class="con-expand entry-descripton"
                      :content="
                        entry.description || 'Keine Beschreibung vorhanden'
                      "
                      :make-apollo-query="makeApolloQuery()"
                    ></parsed-text>
                  </div>
                  <div class="contact-details-wrapper">
                    <p class="font-bold">Ansprechpartner:</p>
                    Name: {{ entry.companyContact.firstName }}
                    {{ entry.companyContact.lastName }} <br />
                    Position: {{ entry.companyContact.position }} <br />
                    Abteilung: {{ entry.companyContact.department }} <br />
                    Telefonnummer:
                    <a :href="'callto:' + entry.companyContact.telephone">{{
                      entry.companyContact.telephone
                    }}</a>
                    <br />
                    Email:
                    <a :href="'mailto:' + entry.companyContact.email">{{
                      entry.companyContact.email
                    }}</a
                    ><br />
                  </div>
                </div>
                <template v-else>
                  <div v-if="entry.project" class="entry-title">
                    {{ entry.project ? entry.project.number : "-" }}
                    {{ entry.project ? entry.project.title : "" }}
                  </div>
                  <parsed-text
                    class="con-expand entry-descripton"
                    :content="
                      entry.description || 'Keine Beschreibung vorhanden'
                    "
                    :make-apollo-query="makeApolloQuery()"
                  ></parsed-text>
                </template>
              </template>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ActionForm from "./Form";
import ParsedText from "../../components/util/ParsedText.vue";
const COMPANY_CONTACT_QUERY = `  companyContact{
    firstName
    lastName
    id
    department
    telephone
    email
    position
  }
`;
const ACTION_PAGE_QUERY = (nameColumn, showCompanyContact) => gql`
  query ActionsPage($page: Int!, $size: Int, $filter: ActionFilter) {
    actionsPage(page: $page, size:$size filter: $filter) {
      results {
        id
        description
        done
        title
        type {
          id
          ${nameColumn}
        }
        project {
          id
          number
          title
        }
        consultant {
          id
          firstName
          lastName
        }
        automatic
        dueAt
        remindAt
        createdAt
        remindAt${showCompanyContact ? COMPANY_CONTACT_QUERY : ""}
      }
    }
  }
`;

export default {
  components: {
    ActionForm,
    ParsedText
  },
  props: {
    viewOnly: { type: Boolean, default: false },
    isHistory: { type: Boolean, default: false },
    type: { type: String, required: true },
    resourceId: { type: String, required: true },
    showCompanyContact: { type: Boolean, default: false }
  },
  data() {
    return {
      fetchFailed: false,
      editing: null,
      selected: "",
      form: {
        description: "",
        done: true,
        refID: null,
        refType: null,
        typeID: null,
        applicantID: null,
        consultantID: null,
        projectID: null,
        dueAt: new Date()
      }
    };
  },
  apollo: {
    actionsPage: {
      query() {
        return ACTION_PAGE_QUERY(this.nameColumn, this.showCompanyContact);
      },
      fetchPolicy: "network-only",
      variables() {
        return {
          page: 1,
          size: 200,
          filter: {
            refType: this.type,
            refID: this.resourceId,
            done: this.isHistory
          }
        };
      }
    },
    me: gql`
      query {
        me {
          id
          consultant {
            id
          }
          group {
            id
          }
        }
      }
    `
  },
  computed: {
    nameColumn() {
      return this.isHistory ? "nameHistory" : "nameResubmission";
    },
    showRemindAt() {
      let result = false;
      for (const entry of this.actionsPage.results) {
        if (entry.remindAt) {
          result = true;
        }
      }
      return result;
    }
  },
  watch: {
    isHistory: {
      immediate: true,
      handler(v) {
        this.form.done = v;
      }
    },
    type: {
      immediate: true,
      handler(v) {
        this.form.refType = v;
      }
    },
    me: {
      handler() {
        this.form.consultantID = this.me.consultant.id;
        this.form.groupID = this.me.group.id;
      }
    }
  },
  methods: {
    //To my best knowledge this is neccessary beacuse Components inside of scoped slots inherit
    //A differnet vue instance on which apollo is not inititalized properly, so the method to make
    //requests has to be injected from the parent component into the child component.
    makeApolloQuery() {
      return (name, options) => {
        this.$apollo.addSmartQuery(name, options);
      };
    },
    openForm(id) {
      document.querySelectorAll(".accordion-content").forEach(el => {
        el.style.maxHeight = "0px";
      });

      this.selected = id === this.selected ? null : id;
      if (!this.selected) {
        return;
      }

      let isLoadedInterval = setInterval(() => {
        if (id !== -1) {
          this.$nextTick().then(() => {
            let content = document.querySelector(".accordion-content");
            content.style.maxHeight = content.scrollHeight + "px";
          });

          clearInterval(isLoadedInterval);
        }
      }, 20);
    },
    async submitActionForm() {
      this.form.refID = this.resourceId;
      const queryParams = this.editing
        ? "$id: ID!, $input: ActionInput!"
        : "$input: NewAction!";
      const query = this.editing
        ? "updateAction(id: $id, input: $input)"
        : "createAction(input: $input)";
      const variables = this.editing
        ? {
            id: this.editing,
            input: Object.prepareGqlInput(
              this.form,
              ["type", "consultant", "project"],
              ["createdAt", "refID", "automatic"]
            )
          }
        : {
            input: this.form
          };

      await this.$apollo.mutate({
        mutation: gql`
            mutation(${queryParams}) {
              ${query} {
                id
                description
                done
                type {
                  id
                  ${this.nameColumn}
                }
                consultant {
                  id
                  firstName
                  lastName
                }
                ref {
                  ... on Applicant {
                    id
                    firstName
                    lastName
                  }
                }
                dueAt
                remindAt
                createdAt
                remindAt
              }
            }
          `,
        variables,
        update: (store, { data: { createAction, updateAction } }) => {
          const data = store.readQuery({
            query: ACTION_PAGE_QUERY(this.nameColumn),
            variables: {
              page: 1,
              filter: {
                refType: this.type,
                refID: this.$route.params.id,
                done: true
              }
            }
          });

          if (this.editing) {
            data.actionsPage.results.forEach((e, i) => {
              if (e.id === this.editing) {
                data.actionsPage.results[i] = updateAction;
              }
            });
            this.editing = null;
          } else {
            data.actionsPage.results.unshift(createAction);
          }

          store.writeQuery({
            query: ACTION_PAGE_QUERY(this.nameColumn),
            data
          });

          this.form = {
            description: "",
            done: this.isHistory,
            refID: this.resourceId,
            refType: this.type,
            typeID: null,
            applicantID: null,
            consultantID: null,
            projectID: null
          };
        }
      });

      this.form.title = "";
      this.form.description = "";
      this.form.projectID = null;
      this.form.typeID = null;

      this.$apollo.queries.actionsPage.refetch();

      this.$vs.notify({
        title: "Gespeichert",
        text: "Eingabe wurde erfolgreich gespeichert",
        color: "success",
        icon: "query_builder",
        position: "bottom-center"
      });
    },
    editEntry(i, data) {
      this.editing = data.id;
      this.form = JSON.parse(JSON.stringify(data));
      this.openForm(1);
    },
    doneEntry(i, data) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Erledigt bestätigen",
        text: `Du bist dabei, eine Wiedervorlage als erledigt zu markieren.`,
        accept: async () => {
          this.actionsPage.results.splice(i, 1);

          await this.$apollo.mutate({
            mutation: gql`
              mutation($id: ID!) {
                markActionDone(id: $id) {
                  id
                }
              }
            `,
            variables: {
              id: data.id
            }
          });

          this.$apollo.queries.actionsPage.refetch();
        },
        acceptText: "Fertig",
        cancelText: "Abbrechen"
      });
    },
    deleteRecord(i, data) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei, eine Wiedervorlage zu löschen. Möchtest du diese wirklich löschen?`,
        accept: async () => {
          this.actionsPage.results.splice(i, 1);

          await this.$apollo.mutate({
            mutation: gql`
              mutation($id: ID!) {
                deleteAction(id: $id) {
                  id
                }
              }
            `,
            variables: {
              id: data.id
            }
          });

          this.$apollo.queries.actionsPage.refetch();
        },
        acceptText: "Löschen",
        cancelText: "Abbrechen"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}
.contact-details-wrapper {
  min-width: min-content;
  flex-shrink: 1;
}
</style>
